import axios from "axios";
import { AuthService } from "../service/auth.service";
import { ToastService } from "../service/toast.service";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

let isRedirecting = false;

api.interceptors.request.use((config) => {
  if (isRedirecting) {
    return Promise.reject(new Error("Redirecting to login..."));
  }

  const token = AuthService.getToken();
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,

  async (err) => {
    const status = err?.response?.status ?? 0;
    const url = err?.config?.url ?? "";
    const errorMessage = err.response?.data?.message || "An error occurred";

    const authEndpoints = [
      "auth/sign-in", 
      "auth/sign-up", 
      "auth/reset", 
      "auth/nw-password"
    ];
    
    if (authEndpoints.some(endpoint => url.includes(endpoint))) {
      return Promise.reject(err);
    }

    if (status === 401) {
      if (!isRedirecting) {
        isRedirecting = true;
        
        ToastService.error("Your session has expired. Redirecting to login...", {
          duration: 5000
        });
        
        AuthService.logout();
        
        setTimeout(() => {
          window.location.replace("/");
        }, 1500);
      }
      
      return Promise.reject(new Error("Unauthorized - session expired"));
    }

    if (err.code === "ERR_NETWORK") {
      if (!err.response) {
        const token = AuthService.getToken();
        
        if (token && !isRedirecting) {
          isRedirecting = true;
          
          ToastService.error("Your session has expired. Redirecting to login...", {
            duration: 5000
          });
          
          AuthService.logout();
          
          setTimeout(() => {
            window.location.replace("/");
          }, 1500);
          
          return Promise.reject(new Error("Session expired"));
        }
      }
      
      ToastService.error("Network issue detected. Please check your connection.");
      return Promise.reject(err);
    }

    if (status >= 500) {
      ToastService.error("Server error. Please try again later.");
      return Promise.reject(err);
    }

    if (status >= 400 && status < 500) {
      ToastService.error(errorMessage);
      return Promise.reject(err);
    }

    ToastService.error("An unknown error occurred.");
    return Promise.reject(err);
  }
);

export default api;